import { Inbox } from "lucide-react";

export const AionEmptyState = ({ icon: Icon = Inbox, title, description, testId }) => (
  <div className="aion-empty-state" data-testid={testId}>
    <Icon className="aion-empty-icon" aria-hidden="true" />
    <h3 data-testid={`${testId}-title`}>{title}</h3>
    <p data-testid={`${testId}-description`}>{description}</p>
  </div>
);